import Search from 'components/audio-guide/search';
import styles from 'components/audio-guide/audio-guide.module.scss';
import MinimalHeader from 'components/headers/minimal-header';

const AudioGuideHeader = (props: IProps) => {
	const {
		title,
		stopNumber,
		replaceRoute,
		pageUrl,
		displayLanguageFilter = false,
	} = props;

	return (
		<MinimalHeader
			heading={title}
			displayLanguageFilter={displayLanguageFilter}
		>
			<div className={styles.searchSection}>
				<Search
					stopNumber={stopNumber}
					pageUrl={pageUrl}
					replaceRoute={replaceRoute}
				/>
			</div>
		</MinimalHeader>
	);
};

interface IProps {
	displayLanguageFilter?: boolean;
	title: string;
	stopNumber?: string;
	replaceRoute?: boolean;
	pageUrl?: string;
}

export default AudioGuideHeader;
